<app-header></app-header>
<app-menu></app-menu>

<div nxLayout="grid">
  <div nxRow class="nx-margin-left-2xl nx-margin-right-2xl">
    <div nxCol="12">
      <nx-tab-group mobileAccordion="false">

        <!-- ═══════════════════════════════════════════════════════ Tab 1 -->
        <nx-tab label="Dealer Commission">
          <div class="tab__content">
            <app-admin-commission-invoice></app-admin-commission-invoice>
          </div>
        </nx-tab>

        <!-- ═══════════════════════════════════════════════════════ Tab 2 -->
        <nx-tab label="Dealer Claim">
          <div class="tab__content">
            <app-dealerclaim></app-dealerclaim>
          </div>
        </nx-tab>

        <!-- ═══════════════════════════════════════════════════════ Tab 3 -->
        <nx-tab label="PFU Invoices">
          <div class="tab__content">
            <app-admin-pfu-invoice></app-admin-pfu-invoice>
          </div>
        </nx-tab>

      </nx-tab-group>
    </div>
  </div>
</div>

<app-footer></app-footer>
